import { CellContext } from '@tanstack/react-table';
import { CellLink } from '@/components/table/_fieldDefinitions/_base/CellLink.tsx';
import { CANCELLED_RECORD_CLASS } from '@/components/table/_fieldDefinitions/_base/cancelledRecord.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { cn } from '@/lib/utils.ts';
import { SimpleNestedClient } from '@/features/dashboard/clients/types/SimpleNestedClient.ts';
import { ClientStatus } from '@/features/dashboard/clients/types/ClientStatus.ts';

export const nestedClientFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as SimpleNestedClient | null | undefined;
  // jOOQ oddaje brak osoby jako obiekt z samymi `null`-ami, nie jako `null`.
  if (!value?.id) return <EmptyValue />;
  const cancelled = value.status === ClientStatus.CANCELLED;
  return (
    <CellLink
      to="/app/clients/$clientId/info"
      params={{ clientId: value.id }}
      importance={info.column.columnDef.meta?.importance}
      className={cn(cancelled && CANCELLED_RECORD_CLASS)}
    >
      {value.firstName} {value.lastName}
    </CellLink>
  );
};
